import { useCallback, useState } from 'react';
import { License } from '../../components/License';
import { Passport } from '../../components/Passport';
import {
	StyledBottomDec,
	StyledCard,
	StyledCard1Shadow,
	StyledCard2,
	StyledCard2Shadow,
	StyledCardWrapper1,
	StyledCardWrapper2,
	StyledCardsContainer,
	StyledSvgDefs,
	StyledTopMask,
	StyledWallet,
	StyledWalletText,
} from './Documents.styled';

const Documents = () => {
	const [selectedCard, setSelectedCard] = useState<null | 'top' | 'bottom'>(
		null,
	);
	const [animPhase, setAnimPhase] = useState<null | {
		which: 'top' | 'bottom';
		phase: 'extract' | 'collapse';
	}>(null);
	const [maskOff, setMaskOff] = useState<{ top: boolean; bottom: boolean }>({
		top: false,
		bottom: false,
	});
	const [forceZ, setForceZ] = useState<{ top: boolean; bottom: boolean }>({
		top: false,
		bottom: false,
	});

	const handleClickTop = useCallback(() => {
		setSelectedCard((prev) => {
			if (prev === 'bottom') {
				setAnimPhase({ which: 'bottom', phase: 'collapse' });
				setForceZ((s) => ({ ...s, bottom: true }));
				setTimeout(() => {
					setMaskOff((m) => ({ ...m, bottom: false }));
					setForceZ((s) => ({ ...s, bottom: false }));
				}, 160);
				setTimeout(() => {
					setMaskOff((m) => ({ ...m, bottom: false }));
					setAnimPhase(null);
					setSelectedCard('top');
					setAnimPhase({ which: 'top', phase: 'extract' });
					setForceZ((s) => ({ ...s, top: true }));
					setTimeout(() => setMaskOff((m) => ({ ...m, top: true })), 160);
					setTimeout(() => {
						setForceZ((s) => ({ ...s, top: false }));
						setMaskOff((m) => ({ ...m, top: true }));
						setAnimPhase(null);
					}, 380);
				}, 380);
				return null;
			}

			const next = prev === 'top' ? null : 'top';
			setAnimPhase({ which: 'top', phase: next ? 'extract' : 'collapse' });
			setForceZ((s) => ({ ...s, top: true }));

			if (next) {
				setTimeout(() => setMaskOff((m) => ({ ...m, top: true })), 160);
				setTimeout(() => {
					setForceZ((s) => ({ ...s, top: false }));
					setMaskOff((m) => ({ ...m, top: true }));
					setAnimPhase(null);
				}, 380);
			} else {
				setTimeout(() => {
					setMaskOff((m) => ({ ...m, top: false }));
					setForceZ((s) => ({ ...s, top: false }));
				}, 160);
				setTimeout(() => {
					setMaskOff((m) => ({ ...m, top: false }));
					setAnimPhase(null);
				}, 380);
			}
			return next;
		});
	}, []);

	const handleClickBottom = useCallback(() => {
		setSelectedCard((prev) => {
			if (prev === 'top') {
				setAnimPhase({ which: 'top', phase: 'collapse' });
				setForceZ((s) => ({ ...s, top: true }));
				setTimeout(() => {
					setMaskOff((m) => ({ ...m, top: false }));
					setForceZ((s) => ({ ...s, top: false }));
				}, 160);
				setTimeout(() => {
					setMaskOff((m) => ({ ...m, top: false }));
					setAnimPhase(null);
					setSelectedCard('bottom');
					setAnimPhase({ which: 'bottom', phase: 'extract' });
					setForceZ((s) => ({ ...s, bottom: true }));
					setTimeout(() => setMaskOff((m) => ({ ...m, bottom: true })), 160);
					setTimeout(() => {
						setForceZ((s) => ({ ...s, bottom: false }));
						setMaskOff((m) => ({ ...m, bottom: true }));
						setAnimPhase(null);
					}, 380);
				}, 380);
				return null;
			}

			const next = prev === 'bottom' ? null : 'bottom';
			setAnimPhase({ which: 'bottom', phase: next ? 'extract' : 'collapse' });
			setForceZ((s) => ({ ...s, bottom: true }));

			if (next) {
				setTimeout(() => setMaskOff((m) => ({ ...m, bottom: true })), 160);
				setTimeout(() => {
					setForceZ((s) => ({ ...s, bottom: false }));
					setMaskOff((m) => ({ ...m, bottom: true }));
					setAnimPhase(null);
				}, 380);
			} else {
				setTimeout(() => {
					setMaskOff((m) => ({ ...m, bottom: false }));
					setForceZ((s) => ({ ...s, bottom: false }));
				}, 160);
				setTimeout(() => {
					setMaskOff((m) => ({ ...m, bottom: false }));
					setAnimPhase(null);
				}, 380);
			}
			return next;
		});
	}, []);

	const isTopExtracted = selectedCard === 'top';
	const isBottomExtracted = selectedCard === 'bottom';

	const topTilt =
		animPhase?.which === 'top' && animPhase.phase === 'collapse'
			? -2
			: isTopExtracted
			? -2
			: 0;
	const bottomTilt =
		animPhase?.which === 'bottom' && animPhase.phase === 'collapse'
			? -2
			: isBottomExtracted
			? -2
			: 0;

	return (
		<StyledWallet>
			<StyledSvgDefs width="520" height="300" viewBox="0 0 520 300">
				<defs>
					<clipPath id="walletCutout">
						<path
							clipRule="evenodd"
							d="
						M -100 -450 H 620 V 300 H -100 Z
						M 0.99 40.86
						H 52.66
						C 64.47 40.86 76.02 37.36 85.84 30.81
						L 115.51 10.99
						C 125.33 4.44 136.88 0.99 148.69 0.99
						H 260.24
						H 368.74
						C 382.33 0.99 395.51 5.61 406.12 14.09
						L 423.21 27.77
						C 433.82 36.24 447 40.86 460.59 40.86
						H 519.01
						V 269.35
						C 519.01 285.85 505.64 299.01 489.31 299.01
						H 30.69
						C 14.36 299.01 0.99 285.85 0.99 269.35
						V 40.86 Z
					"
						/>
					</clipPath>
				</defs>
			</StyledSvgDefs>

			<StyledCardsContainer>
				<StyledTopMask
					$topPad={
						animPhase?.which === 'top' && animPhase.phase === 'collapse'
							? 220
							: 0
					}
					$disabled={isTopExtracted || maskOff.top}
				>
					<StyledCard1Shadow $isTopExtracted={isTopExtracted} />
					<StyledCardWrapper1
						$forceZ={forceZ.top}
						$isExtracted={isTopExtracted}
						onClick={handleClickTop}
					>
						<StyledCard
							$animPhase={
								animPhase?.which === 'top' ? animPhase.phase : undefined
							}
							$tilt={topTilt}
						>
							<License />
						</StyledCard>
					</StyledCardWrapper1>
				</StyledTopMask>
				<StyledCard2Shadow />
				<StyledCardWrapper2
					$forceZ={forceZ.bottom}
					$maskOff={maskOff.bottom}
					$isExtracted={isBottomExtracted}
					onClick={handleClickBottom}
				>
					<StyledCard2
						$animPhase={
							animPhase?.which === 'bottom' ? animPhase.phase : undefined
						}
						$tilt={bottomTilt}
						$isExtracted={isBottomExtracted}
					>
						<Passport />
					</StyledCard2>
				</StyledCardWrapper2>
			</StyledCardsContainer>

			<StyledBottomDec>
				<StyledWalletText />
			</StyledBottomDec>
		</StyledWallet>
	);
};

export { Documents };
